
// Remove the getViewsForProduct function since we're now using real views data
// export const getViewsForProduct = (receiptId: string): number => {
//   // Use receipt ID as seed for consistent random views
//   const seed = receiptId.split('').reduce((a, b) => a + b.charCodeAt(0), 0);
//   return Math.floor((seed % 500) + 50); // Random views between 50-550
// };

export const getStatusColor = (status: string) => {
  switch (status.toLowerCase()) {
    case "new":
      return "bg-blue-50 text-blue-700 border-blue-200";
    case "processing":
      return "bg-yellow-50 text-yellow-700 border-yellow-200";
    case "paid":
      return "bg-green-50 text-green-700 border-green-200";
    case "shipped":
      return "bg-purple-50 text-purple-700 border-purple-200";
    case "delivered":
      return "bg-emerald-50 text-emerald-700 border-emerald-200";
    case "completed":
      return "bg-teal-50 text-teal-700 border-teal-200";
    case "cancelled":
    case "canceled":
      return "bg-red-50 text-red-700 border-red-200";
    case "returned":
      return "bg-orange-50 text-orange-700 border-orange-200";
    case "refunded":
      return "bg-pink-50 text-pink-700 border-pink-200";
    default:
      return "bg-gray-50 text-gray-700 border-gray-200";
  }
};

export const formatAddress = (order: any) => {
  const parts = [];
  if (order.address && order.address.trim() && order.address !== 'N/A') {
    parts.push(order.address.trim());
  }
  if (order.city && order.city.trim()) {
    parts.push(order.city.trim());
  }
  if (order.zip && order.zip.trim()) {
    parts.push(order.zip.trim());
  }
  return parts.length > 0 ? parts.join(', ') : 'Address not provided';
};

export const hasMultipleItems = (order: any) => {
  return order.items && order.items.length > 1;
};

export const getItemsText = (order: any) => {
  if (!order.items || order.items.length === 0) {
    return order.productName;
  }
  
  if (order.items.length === 1) {
    return order.items[0].title;
  }
  
  return `${order.items[0].title} (+${order.items.length - 1} more)`;
};
